import { render, staticRenderFns } from "./StTeaserMediaDownload.vue?vue&type=template&id=524bc538"
import script from "./StTeaserMediaDownload.vue?vue&type=script&lang=ts"
export * from "./StTeaserMediaDownload.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports